import { useLanguage } from "../i18n/LanguageContext";

type TabletMockupProps = {
    variant?: "grid" | "list";
};

export function TabletMockup({ variant = "grid" }: TabletMockupProps) {
    const { t } = useLanguage();
    const gridItems = t.tablet.gridItems;
    const listItems = t.tablet.listItems;

    return (
        <div className="tablet">
            <div className="tabletScreen">
                <div className="tabletTop">
                    <span className="tabletTitle">
                        {variant === "grid" ? t.tablet.menu : t.tablet.catalog}
                    </span>
                    <span className="tabletSearch">⌕</span>
                </div>

                <div className="tabletTabs">
                    {t.tablet.tabs.map((tab, index) => (
                        <span key={tab} className={index === 0 ? "active" : undefined}>
                            {tab}
                        </span>
                    ))}
                </div>

                {variant === "grid" ? (
                    <div className="dishGrid">
                        {gridItems.map((item) => (
                            <article className="dishCard" key={item.title}>
                                <img className="dishImage" src={item.image} alt={item.title} />

                                <div className="dishInfo">
                                    <span>{item.title}</span>
                                    <strong>{item.price}</strong>
                                </div>

                                <button
                                    className="dishAdd"
                                    type="button"
                                    aria-label={t.tablet.addAria}
                                >
                                    +
                                </button>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className="dishList">
                        {listItems.map((item) => (
                            <article className="dishRow" key={item.title}>
                                <img className="dishThumb" src={item.image} alt={item.title} />

                                <div>
                                    <span>{item.title}</span>
                                    <small>{item.description}</small>
                                    <strong>{item.price}</strong>
                                </div>

                                <button
                                    className="dishAdd"
                                    type="button"
                                    aria-label={t.tablet.addAria}
                                >
                                    +
                                </button>
                            </article>
                        ))}
                    </div>
                )}

                <div className="cartBar">
                    <span>{t.tablet.cart}</span>
                    <strong>{t.tablet.cartTotal}</strong>
                </div>
            </div>
        </div>
    );
}
